define('ANSI/Components/Events/CustomEventDetails',['jquery'], function ($) {

    function CustomEventDetails(scope, readMoreLabel, readLessLabel) {
        $('.js-read-more', scope).on("click", function (e) {
            e.preventDefault();
            $('.read', scope).toggleClass('read-less');
            if ($(this).text() === readLessLabel) $(this).text(readMoreLabel);
            else $(this).text(readLessLabel);
        });
    }

    CustomEventDetails.init = function init(args) {
        return args.IsEditorEditing === true ? null : new CustomEventDetails(args.scope, args.ReadMoreLabel, args.ReadLessLabel);
    };

    return CustomEventDetails;

});
